// extracted by mini-css-extract-plugin
export var errorBanner = "_eh-2";
export var scroller = "_eh-0";
export var thinking = "_eh-1";
export var visuallyHidden = "_eh-3";